import * as actionType from "../constants/actionTypes";

const initialState = {
  loading: false,
  success: false,
  error: null,
  message: "",
};

const saveConnectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SAVE_CONNECTION_PENDING:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
        message: "Saving connection...",
      };

    case actionType.SAVE_CONNECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        message: action.payload?.content || "Connection saved successfully",
      };

    case actionType.SAVE_CONNECTION_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        message: "",
      };

    case actionType.SAVE_CONNECTION_EMPTY:
      return {
        ...state,
        loading: false,
        success: false,
        error: null,
        message: "No response received.",
      };



    default:
      return state;
  }
};

export default saveConnectionReducer;
